<template>
    <div class="flex w-full space-y-2" :class="[skeletonClass({ size })]">
        <div class="p-2 w-full loading rounded-lg bg-gray-900"></div>
    </div>
</template>
<script lang="ts" setup>
// * cva
import { cva } from "class-variance-authority";

// * interfaces
interface Props {
    size?: "sm" | "md" | "lg" | "xl";
}

// * props
defineProps<Props>();

// * computed properties
const skeletonClass = cva("", {
    variants: {
        size: {
            sm: "sm",
            md: "md",
            lg: "lg",
            xl: "xl",
        },
    },
    compoundVariants: [
        {
            size: "sm",
            class: "h-10",
        },
        {
            size: "md",
            class: "h-16",
        },
        {
            size: "lg",
            class: "h-24",
        },
        {
            size: "xl",
            class: "h-32",
        },
    ],
    defaultVariants: {
        size: "md",
    },
});
</script>
